import { Carousel, Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

export default function CommunityResponsiveness(){
    const { t } = useTranslation();

    return(
        <article id="communityresponsiveness">
            <section className="comunity-responsiveness">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t(`lifeatcentrico.communityresponsiveness.title`)}</div>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={12}>
                            <Carousel interval={2500}>
                                <Carousel.Item>
                                    <div className="events-wrapper">
                                        <Row>
                                            <Col md={4} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/visit1.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Eureka School</div>
                                                        <div className="event-description">Centrico colleagues spending time with the children of Eureka, established by the Sella group in partnership with AID India in 2006.</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={4} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/visit2.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Udavum Karangal</div>
                                                        <div className="event-description">Annual visit to Udavum Karangal on Sella Founder's day</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={4} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/visit3.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">DaanUtsav</div>
                                                        <div className="event-description">Celebrating #daanutsav with our CSR partner, AWARE India, fulfilling the Diwali wishes of many children</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={12} className="text-center">
                            <a rel='csr_policy_centrico' href={require('./CSR_Policy_wef2022-23_Centrico-India.pdf')} className="btn btn-link" target="_blank">Our CSR Policy</a>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}